<script setup>
import {computed} from "vue";
import {mdiBackspace} from "@mdi/js";

const model = defineModel({type: String});
const props = defineProps({
    maxLength: {
        type: Number,
        default: 4,
    },
    label: String,
});

const modelString = computed(() => {
    if (model.value === null || model.value === undefined) {
        return '';
    }
    return model.value.toString();
});

const keypadButtons = [...Array(10).keys()];

const keypadEnabled = computed(() => {
    return modelString.value.length < props.maxLength;
});
const backspaceEnabled = computed(() => {
    return modelString.value.length > 0;
});

function appendDigit(digit) {
    if (!keypadEnabled.value) {
        return;
    }
    model.value = modelString.value + digit.toString();
}

function deleteLastDigit() {
    if (!backspaceEnabled.value) {
        return;
    }
    model.value = modelString.value.slice(0, -1);
}
</script>

<template>
    <div class="tic-keypad">
        <div class="tic-keypad__label">
            {{ label }}
        </div>

        <v-btn v-for="keypadButton of keypadButtons"
               :key="'k' + keypadButton"
               type="button"
               class="tic-keypad__button"
               size="large"
               variant="flat"
               rounded="sm"
               :height="64"
               :disabled="!keypadEnabled"
               :style="{gridArea: 'k' + keypadButton}"
               @click="appendDigit(keypadButton)">
            {{ keypadButton }}
        </v-btn>

        <v-btn type="button"
               color="red"
               class="tic-keypad__button"
               style="grid-area: backspace;"
               variant="tonal"
               rounded="sm"
               :icon="mdiBackspace"
               :disabled="!backspaceEnabled"
               block
               @click="deleteLastDigit()"/>
    </div>
</template>
